import { Box, styled } from '@mui/material';

export const HSAContributionCardBackground = styled(Box)({
  backgroundColor: "#F6F8F9",
});

export const HSAContributionCardBoder = styled(Box)({
  border: "1px solid #BBC1D0",
  borderRadius: "4px"
});

export const HSATitleHeader = styled(Box)({
  fontSize: "16px"
});

export const HSAContributionLabel = styled(Box)({
  fontSize: "12px",
  color:"#55575E",
  fontWeight: 500
});

export const MaxContributionAmount = styled(Box)({
  fontSize: "12px",
  color: "#707178",
});

export const HSACalculationSymbol = styled(Box)({
  fontSize: "23px"
});

export const HSAContrinutionAmounts = styled(Box)({
  fontSize: "19px",
  color:"#55575E",
  fontWeight: 600
});

export const DontWantContributeBanner = styled(Box)({
  background: "#DEE7FF",
  fontSize: "12px",
});
export const InfoBannerMaxContributionBanner = styled(Box)({
  border: "1px solid #3C548E",
  padding: "10px",
  background: "#DEE7FF",
  borderRadius: "4px",
});
export const ContributionAdjustedBanner = styled(Box)({
  background: "#DEE7FF",
  fontSize: "14px",
  padding: "24px",
  marginTop: "24px",
});
export const ResetContributionButton = styled(Box)({
  textDecoration: "underline",
  fontSize: "14px",
  padding: "12px",
  background: "white",
  color: "var(--branding-primary-600)"
});

export const ContributionCardBanner = styled(Box)({
  background: "#DEE7FF",
  padding: "20px"

});

export const ContributionCardTitle = styled(Box)({
  fontSize: "19px",
  fontWeight: 600,
});
export const ContributionCardDescription= styled(Box)({
  fontSize: "14px",
  marginTop: "6px"
});
